import React from "react";
import PageShell from "../common/page_shell";
import CodingTools from "../inner/coding_tools/coding_tools";

const CodingToolsPage = () => {
  return (
    <PageShell>
      <CodingTools />
    </PageShell>
  );
};

export default CodingToolsPage;
